module.exports = __webpack_public_path__ + "static/media/conffeti.ac389af9.gif";